export default __webpack_public_path__ + "static/media/health-for-all.4af443d5.gif";